import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EnquiryListLayer from "../components/EnquiryListLayer";

const EnquiryListPage = () => {
    return (
        <MasterLayout>
            {/* <div className="breadcrumb-with-buttons mb-20">
                <div className="d-flex align-items-center justify-content-between">
                    <h6 className="page-title mb-0">Enquiry List</h6>
                    <ul className="breadcrumb d-flex align-items-center gap-10">
                        <li className="breadcrumb-item">
                            <a href="#" className="text-secondary-light">
                                CRM
                            </a>
                        </li>
                        <li className="breadcrumb-item">
                            <a href="#" className="text-secondary-light">
                                Enquiry List
                            </a>
                        </li>
                    </ul>
                </div>
            </div> */}
            <EnquiryListLayer />
        </MasterLayout>
    );
};

export default EnquiryListPage;
